import { Injectable } from '@angular/core';

import SocialEntryConfiguration from 'entity/SocialEntryConfiguration';
import RulesController from 'rest/RulesController';

@Injectable({
  providedIn: 'root',
})
export class ScootaverseEntryRulesService {
  private rulesController: RulesController;

  public constructor() {
    this.rulesController = new RulesController();
  }

  public getEntryConfiguration(socialRoomSetId: string, configurationId: string): Promise<SocialEntryConfiguration> {
    return this.rulesController.getEntryConfiguration(socialRoomSetId, configurationId);
  }

  public getEntryConfigurations(socialRoomSetId: string): Promise<SocialEntryConfiguration[]> {
    return this.rulesController.getEntryConfigurations(socialRoomSetId);
  }

  public createEntryConfiguration(
    socialRoomSetId: string,
    entryConfiguration: SocialEntryConfiguration,
  ): Promise<void> {
    return this.rulesController.createEntryConfiguration(socialRoomSetId, entryConfiguration);
  }

  public updateEntryConfiguration(
    socialRoomSetId: string,
    entryConfiguration: SocialEntryConfiguration,
  ): Promise<void> {
    return this.rulesController.updateEntryConfiguration(socialRoomSetId, entryConfiguration);
  }

  public deleteEntryConfiguration(socialRoomSetId: string, configurationId: string) {
    return this.rulesController.removeEntryConfiguration(socialRoomSetId, configurationId);
  }
}
